import logo from './logo.svg';
import './App.css';
import Clock from './components/Clock.js';
import BeachScene from './components/BeachScene.js';

function App() {
  return (
    <div className="App">
      <BeachScene></BeachScene>
    </div>
  );
}

export default App;
